import { Head } from "@inertiajs/react";
import { motion } from "motion/react";

import { Container } from "@/theme1/components/common/Container";
import NewInGrid from "@/theme1/components/newIn/NewInGrid";
import NewInHeader from "@/theme1/components/newIn/NewInHeader";
import NewInHero from "@/theme1/components/newIn/NewInHero";

export default function NewIn({ newInPage }) {
  const page = newInPage ?? {};
  const products = page.products ?? [];

  return (
    <>
      <Head title={page.seo?.title ?? "New In - Captex"}>
        <meta
          name="description"
          content={page.seo?.description ?? ""}
        />
        <meta
          name="keywords"
          content={page.seo?.keywords ?? ""}
        />
      </Head>

      <main className="overflow-hidden">
        <Container className="py-5 sm:py-7 lg:py-10">
          <NewInHero hero={page.hero} />

          {/* <NewInHeader introduction={page.introduction} /> */}

          <section
            id="new-in-products"
            className="scroll-mt-32 pb-20 sm:pb-24 lg:pb-32"
          >
           
            {/* <motion.header
              initial={{ opacity: 0, y: 22 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.55 }}
              className="mb-10 sm:mb-12"
            >
              <p className="text-xs font-black uppercase tracking-[0.32em] text-muted-foreground">
                {page.productsHeader?.eyebrow}
              </p>

              <h2 className="mt-4 text-4xl font-black uppercase leading-[0.95] tracking-[-0.045em] sm:text-5xl lg:text-7xl">
                {page.productsHeader?.title}
              </h2>

              <p className="mt-4 max-w-2xl text-sm leading-7 text-muted-foreground sm:text-base">
                {page.productsHeader?.description}
              </p>
            </motion.header> */}

            <NewInGrid products={products} />
          </section>
        </Container>
      </main>
    </>
  );
}

